export default __webpack_public_path__ + "static/media/Upgrade now.5fe91ab7.png";